/**
 * TagBehavior — helpers d'interactivité/events extraits de Tag (ha/443c).
 *
 * Audit SoC ha/443 : décider du debounce de clic, du verrou disable/enable et
 * du câblage des listeners n'est pas le rôle d'une primitive DOM. On sort ces
 * comportements en fonctions pures sur l'`Element`, testables isolément.
 *
 * Iso-comportement strict vs Tag legacy :
 *  - `addListener` ne câble que si `func` est une fonction, et chaque handler
 *    appelle `event.stopPropagation()` après le callback (inchangé).
 *  - le verrou anti-double-clic utilise l'attribut `e` : "" = désactivé,
 *    "1" = réactivé. Legacy passait par `addAttribute` (→ `translate`) ; ici
 *    les valeurs sont "" / "1" (non préfixées `#`) donc `translate` était un
 *    no-op → `setAttribute` direct est équivalent.
 */

import { timeout } from "../../../HA";

export function addListener(el: Element, name: string, func: any): void {
    if (typeof func === "function") {
        el.addEventListener(name, (event: Event) => {
            func(event);
            event.stopPropagation();
        });
    }
}

export function onChange(el: Element, func: any): void {
    addListener(el, "change", func);
}

export function initEvents(el: Element, events: Map<string, () => void>): void {
    events.forEach((func, name) => { addListener(el, name, func); });
}

function isDisabled(el: Element): boolean {
    return el.getAttribute("e") === "";
}

function disable(el: Element): void {
    el.setAttribute("e", "");
}

function enable(el: Element): void {
    el.setAttribute("e", "1");
}

export function onClick(el: Element, func: any, blockClickDelay = 1000): void {
    addListener(el, "click", (e: Event) => {
        if (isDisabled(el)) return;
        disable(el);
        func(e);
        timeout(() => { enable(el); }, blockClickDelay);
    });
}
